<template>
  <div
    v-for="option in filteredOptions"
    :key="option.id"
    class="input input--dropdown"
  >
    <select
      class="input__element input__element--dropdown"
      @change="handleOptionChange(option, $event)"
    >
      <option selected disabled>Select {{ option.name }}</option>
      <option
        v-for="value in option.values"
        :key="value"
        :selected="isSelectedOption(option, value)"
      >
        {{ value }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "ProductOptions",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState("product", ["selectedOptions"]),
    filteredOptions() {
      return this.options.filter((option) => option.values.length > 1);
    },
  },
  mounted() {
    this.options.forEach((option) => {
      if (option.values.length === 1) {
        this.changeProductOption({
          id: option.id,
          name: option.name,
          value: option.values[0],
        });
      }
    });
  },
  methods: {
    ...mapActions("product", ["changeProductOption"]),
    handleOptionChange(option, { target }) {
      this.changeProductOption({
        id: option.id,
        name: option.name,
        value: target.value,
      });
    },
    isSelectedOption(option, value) {
      return this.selectedOptions.some(
        (selectedOption) =>
          selectedOption.id === option.id && selectedOption.value == value
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form";
</style>
